// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CalendarEvent  {
    _originalTypeClassName = "Loom.BO.CalendarEvent";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CalendarEvent.translate = translateService;
}
this.Title = null;
this.SubTitle = null;
this.ObjectType = null;
this.ObjectId = null;
this.StartDateTime = null;
this.EndDateTime = null;
this.IsAllDay = false;
this.Status = null;
this._key = this.ObjectId = 0; 
}

static translate: TranslateService;
_key: any;
Title:any;
SubTitle:any;
ObjectType:any;
private _ObjectId:any;
get ObjectId(): any {
    return this._ObjectId;
  }
set ObjectId(value: any) {
    this._ObjectId = value;
    this._key = value;
  }
StartDateTime:any;
EndDateTime:any;
IsAllDay:any;
Status:any;
Calendar:any;
static setCalendar = ($this, value) => {
var oldValue = $this.Calendar;
$this.Calendar = value;
if (value != null) {
if (oldValue != null) {
Domain.Calendar.removeCalendarEvent(oldValue, $this);
}
Domain.Calendar.addCalendarEvent(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ObjectId == null || $this.ObjectId == 0;
            }


}